import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCombos = () => {
    const combosSection = document.getElementById('combos');
    if (combosSection) {
      combosSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-30">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 z-50 lg:hidden border-t border-gray-100" data-id="element-31">
          <div className="flex items-center justify-between gap-4" data-id="element-32">
            <div className="flex flex-col" data-id="element-33">
              <span className="text-xs text-gray-500 line-through" data-id="element-34">
                $47.00 USD
              </span>
              <span className="text-lg font-bold text-[#4a7c2c]" data-id="element-35">
                $13.99 USD
              </span>
            </div>

            <div className="flex-1" data-id="element-36">
              <Button fullWidth onClick={scrollToCombos} className="py-3 text-sm shadow-lg shadow-[#4a7c2c]/20" data-id="element-37">
                Comprar ahora →
              </Button>
              <div className="flex items-center justify-center gap-1 mt-1 text-[10px] text-gray-500" data-id="element-38">
                <Lock className="w-3 h-3" data-id="element-39" />
                <span data-id="element-40">Compra protegida</span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}